import { post, put } from '../..';
import {
  BuildingSettingsPriority, Day,
} from '../../../screens/LocationManagement/components/BuildingSettingsModal/data';

type Payload = {
  Building: string,
  Floor: { IsAssetAvailable: boolean },
  Area: { IsAssetAvailable: boolean },
  Space: { IsAssetAvailable: boolean },
  CountryCode: string,
  StateCode: string,
  CityName: string,
  SlaHours: BuildingSettingsPriority[],
  WorkingHours: Day[],
  ExternalId?: string,
  LocationCapacity?: number,
}

const updateBuilding = (
  Building: string,
  floorsCanContainAssets: boolean,
  areasCanContainAssets: boolean,
  spacesCanContainAssets: boolean,
  CountryCode: string,
  StateCode: string,
  CityName: string,
  SlaHours: BuildingSettingsPriority[],
  WorkingHours: Day[],
  LocationId?: string,
  ExternalId?: string,
  LocationCapacity?: number,
) => {
  const body: Payload = {
    Building,
    Floor: { IsAssetAvailable: floorsCanContainAssets },
    Area: { IsAssetAvailable: areasCanContainAssets },
    Space: { IsAssetAvailable: spacesCanContainAssets },
    CountryCode,
    StateCode,
    CityName,
    SlaHours,
    WorkingHours,
    ExternalId,
    LocationCapacity,
  };

  let url: string = 'locations/buildings';
  if (LocationId) {
    url += `/${LocationId}`;
    return put(url, body);
  }
  return post(url, body);
};

export default updateBuilding;
